import React from 'react';
import { useTranslation } from 'react-i18next';
import Page from 'Core/components/Page';
import { useScrollTop } from 'Core/hooks/useScrollTop';
import Card from 'Core/components/FormElements/Card';

const ApplicationDenied = () => {
  document.title = 'Payment Portal - Application Denied';
  useScrollTop();
  const { t } = useTranslation();

  return (
    <Page title={t('easyCredit.page.financing.header')} withStepProgress={false} stickyFooter hideAlert>
      <div className="mt-12 max-w-4xl mx-auto">
        <Card className="bg-gradient-to-br from-white to-gray-50 shadow-xl border-0 overflow-hidden">
          {/* Top accent bar */}
          <div className="h-2 bg-gradient-to-r from-red-400 via-rose-400 to-red-500"></div>

          <div className="p-8 md:p-12">
            <div className="flex flex-col md:flex-row items-center gap-8">
              {/* Denied Icon */}
              <div className="flex-shrink-0 w-40 md:w-56">
                <div className="bg-gradient-to-br from-red-50 to-rose-50 rounded-2xl p-6 shadow-inner">
                  <div className="w-full aspect-square flex items-center justify-center">
                    <div className="relative">
                      <div className="w-32 h-32 md:w-40 md:h-40 bg-gradient-to-br from-red-500 to-rose-500 rounded-full flex items-center justify-center shadow-lg">
                        <svg className="w-20 h-20 md:w-24 md:h-24 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                      </div>
                      <div className="absolute -top-2 -right-2 w-8 h-8 bg-red-300 rounded-full opacity-60"></div>
                      <div className="absolute -bottom-2 -left-2 w-6 h-6 bg-rose-300 rounded-full opacity-60"></div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex-1 text-center md:text-left">
                <div className="inline-flex items-center gap-2 px-4 py-2 bg-red-100 text-red-800 rounded-full text-sm font-semibold mb-4">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                  </svg>
                  {t('easyCredit.applicationDenied.title')}
                </div>

                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 leading-tight">
                  {t('easyCredit.applicationDenied.title')}
                </h2>

                <p className="text-lg text-gray-600 leading-relaxed mb-6">
                  {t('easyCredit.applicationDenied.content')}
                </p>


              </div>
            </div>
          </div>
        </Card>
      </div>
    </Page>
  );
};

export default ApplicationDenied;

